import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import {E} from './util.mjs'
import * as d from './dat.mjs'
import * as ei from './elem-input.mjs'
import * as eff from './elem-form-field.mjs'

export class FormFieldText extends eff.FormField {
  static {dr.reg(this)}
  get Input() {return FormFieldInput}

  initFromSpec(src) {
    src = a.toInst(src, d.UiField)

    const id = this.ctx.seq.nextId()

    return E(super.init(), {},
      E(new this.Label(this), {for: id}).initFromSpec(src),
      E(new this.Input(this), {id}).initFromSpec(src),
    )
  }
}

export class FormFieldInput extends eff.MixFormFieldElem(ei.Input) {
  static {dr.reg(this)}

  initFromSpec(src) {
    const {type, name, value, validation, placeholder} = a.laxStruct(src)
    const {required, pattern} = a.laxStruct(validation)

    return E(this, {
      type, name, value, placeholder, required, pattern,
      class: `form-input`,
    })
  }
}
